export default function NotFound() {
    return (<div className="flex content-center text-center justify-center flex-col">
        <h1 className="text-5xl my-2">Page Not Found</h1>
        <p>Sorry this page wasn't found. Try returning home and navigating again.</p>
    </div>)   
}